export const SOFTLINE_API_SEND_NOTIFICATION = '/v1/push/send'
